export default __webpack_public_path__ + "static/media/klinikBhayangkara.0af2a84b.jpg";